module.exports = __webpack_public_path__ + "assets/img/favicon-danger.png";


//////////////////
// WEBPACK FOOTER
// ./src/main/frontend/assets/img/favicon-danger.png
// module id = ./src/main/frontend/assets/img/favicon-danger.png
// module chunks = 1